import React, { useState } from 'react'
import Button from '../button'
import { ButtonUpload, Wrapper } from './styles'

type Props = {
  'data-qa'?: string
  handleFile: Function
  children?: any
  text?: string
}

const FileUploader: React.FC<Props> = (props: Props) => {
  const hiddenFileInput = React.useRef(null)
  const [fileName, setFileName] = useState<String>()
  const [showButton, setShowButton] = useState<boolean>(false)

  const handleClick = (): void => {
    if (fileName) return
    hiddenFileInput.current.click()
  }

  const handleChange = (event): void => {
    const fileUploaded: any = event.target?.files[0]
    setFileName(fileUploaded?.name)
    props.handleFile(fileUploaded)
    setShowButton(true)
  }

  const clearInput = (): void => {
    setFileName(null)
    hiddenFileInput.current.value = null
    setShowButton(false)
  }

  const type = fileName ? 'set' : 'unset'
  return (
    <Wrapper onClick={handleClick} type={type} data-qa={props['data-qa']}>
      <div>
        <ButtonUpload
          child={props.children}
          data-qa={props['data-qa'] && `${props['data-qa']}-button`}
        >
          {fileName ||
            (props.children ? props.children : 'Adicione um arquivo')}
        </ButtonUpload>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleChange}
          style={{ display: 'none' }}
        />
      </div>
      {showButton && (
        <Button
          theme={'tertiary'}
          onClick={clearInput}
          data-qa={props['data-qa'] && `${props['data-qa']}-clear-button`}
        >
          {props.text}
        </Button>
      )}
    </Wrapper>
  )
}

FileUploader.defaultProps = {
  text: 'Cancelar',
}

export default FileUploader
